/**
 * Formata o número do cartão para exibição com máscara
 * Mostra apenas os 4 primeiros e 4 últimos dígitos
 * @param {string} cardNumber - Número do cartão
 * @returns {string} - Número mascarado formatado (ex: 1234 **** **** 5678)
 */
export const formatCardDisplay = (cardNumber) => {
  if (!cardNumber) return '';
    
  // Remove todos os caracteres não numéricos (incluindo asteriscos antigos)
  const cleanNumber = cardNumber.replace(/[^\d]/g, '');
    
  // Precisa ter pelo menos 8 dígitos para criar a máscara
  if (cleanNumber.length < 8) {
    return cardNumber;
  }
  
  // Pega os 4 primeiros dígitos
  const first4 = cleanNumber.substring(0, 4);
  
  // Pega os 4 últimos dígitos
  const last4 = cleanNumber.substring(cleanNumber.length - 4);
  
  // Cria a máscara no formato: 1234 **** **** 5678
  const maskedNumber = `${first4} **** **** ${last4}`;
    
  return maskedNumber;
};

/**
 * Formata o número do cartão com espaços - Baseado no AddCardModal
 */
export const formatCardNumber = (value) => {
  const cleanValue = value.replace(/\D/g, '');
  const match = cleanValue.match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
  const formatted = !match[2] ? match[1] : `${match[1]} ${match[2]}${match[3] ? ` ${match[3]}` : ''}${match[4] ? ` ${match[4]}` : ''}`;
  return formatted;
};

/**
 * Formata CPF/CNPJ/NIF - Baseado no AddCardModal
 */
export const formatDocumentNumber = (value) => {
  const cleanValue = value.replace(/\D/g, '');
  if (cleanValue.length <= 11) {
    // CPF: 000.000.000-00
    return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else {
    // CNPJ: 00.000.000/0000-00
    return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
};